var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"example"},[_c('div',{staticClass:"text-center"},[_c('p',[_vm._v(_vm._s(_vm.$t("registerEvent.mredirect")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }